import { render, staticRenderFns } from "./SeriesStatus.vue?vue&type=template&id=ebfafda0"
import script from "./SeriesStatus.vue?vue&type=script&lang=js"
export * from "./SeriesStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports